import { Component } from "react";
import { Highcharts } from "extensions/highcharts";
import "highcharts/es-modules/Series/AreaRange/AreaRangeSeries";

import {
    HighchartsChart,
    Tooltip,
    Chart,
    XAxis,
    YAxis,
    LineSeries,
    AreaSeries,
    AreaRangeSeries,
    PlotLine,
    HighchartsProvider
} from "react-jsx-highcharts";

import {
    normalizeSeriesData,
    plotOptions,
    getTickInterval,
    dateTimeLabelFormats
} from "./utils";

export class TimelineChart extends Component {
    static defaultProps = {
        yAxisPlotLines: [],
        yAxisProps: {}
    };
    
    getChart = (chart) => {
        this.chart = chart;
        if (typeof this.props.chartSetter === "function") {
            this.props.chartSetter(chart);
        }
    };
    
    getYAxisProps() {
        const YAxisProps = {
            ...this.props.yAxisProps
        };
        
        const types = this.props.series.map(({ valueType }) => valueType);
        if (types.every((t) => t === "rate")) {
            YAxisProps.labels = {
                format: "{value}%"
            };
            YAxisProps.min = 0;
            YAxisProps.max = 100;
            YAxisProps.tickInterval = 50;
        }
        
        if (this.props.yAxisLabelFormat) {
            YAxisProps.labels = {
                ...YAxisProps.labels,
                format: this.props.yAxisLabelFormat
            };
        }
        
        return YAxisProps;
    }
    
    render() {
        return (
            <HighchartsProvider Highcharts={Highcharts}>
                <HighchartsChart callback={this.getChart} plotOptions={plotOptions}>
                    <Chart animation={false} height={this.props.height} backgroundColor="transparent"/>
                    <Tooltip
                        pointFormat={this.props.tooltipPointFormat || "<span style=\"color:{point.color}\">\u25CF</span> {series.name}: <b>{point.y}</b><br/>"}
                        shared
                        crosshairs
                        dateTimeLabelFormats={this.props.freq === "month" ? { day: "%B %Y" } : dateTimeLabelFormats}
                    />
                    <XAxis type="datetime" dateTimeLabelFormats={dateTimeLabelFormats} {...getTickInterval(this.props.freq)} />
            
                    <YAxis {...this.getYAxisProps()}>
                        {this.props.yAxisTitle && <YAxis.Title>{this.props.yAxisTitle}</YAxis.Title>}
                        {this.props.yAxisPlotLines.map((data, index) => <PlotLine key={index++} {...data}/>)}
                        {normalizeSeriesData(this.props.data, this.props.series).map((s, i) => {
                            if (s.type === "area") {
                                return <AreaSeries {...s} key={i++}/>;
                            }
                        
                            if (s.type === "arearange") {
                                return <AreaRangeSeries {...s} key={i++}/>;
                            }
                        
                            return <LineSeries {...s} key={i++}/>;
                        })}
                    </YAxis>
                </HighchartsChart>
            </HighchartsProvider>
        );
    }
}
